import { ChangeDetectionStrategy, Component, forwardRef, input, viewChild } from '@angular/core';

import {FieldOkComponent} from '@softline/dynamic';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {DefaultFieldOkConfiguration} from '../field-ok-configuration';
import {FieldOkWrapper} from '../field-ok-wrapper';

@Component({
    selector: 'soft-preisebene-field-ok',
    imports: [FieldOkComponent],
    templateUrl: './preisebene-field-ok.component.html',
    styleUrl: './preisebene-field-ok.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PreisebeneFieldOkComponent),
            multi: true,
        },
    ]
})
export class PreisebeneFieldOkComponent extends FieldOkWrapper<DefaultFieldOkConfiguration> implements ControlValueAccessor {

  override value = input<object | null>(null);
  override configuration = input<DefaultFieldOkConfiguration | null>(null);
  override parameters = input<object>({});
  override readonly = input<boolean>(false);
  readonly required = input<boolean>(false);

  readonly fieldOkComponent = viewChild.required(FieldOkComponent);
}
